module.exports = "<div class=\"hidden-drop-down\" id=\"small-list-links\">\n  <ul>\n    <li ng-click=\"vm.goToJobs()\" class=\"nowrap\">\n      <!--href=\"/events\"-->\n      <a href=\"\">Jobs</a>\n    </li>\n    <li ng-repeat=\"event in vm.events\" class=\"nowrap\" ng-click=\"vm.goToJobOverview(event)\">\n      <a> {{event.name}} </a>\n    </li>\n  </ul>\n  <!-- href=\"/event/{{event.id}}/overview\" -->\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./client/app/common/jobbleheader/jobsdropdown/jobsdropdown.html
// module id = 78
// module chunks = 0